import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import logo from "../../Assets/logo.png";
import axios from "axios";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const toggleShowPassword = () => setShowPassword((s) => !s);
  const closeSnack = () =>
    setSnack((s) => ({ ...s, open: false }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSnack({ open: false, message: "", severity: "info" });

    try {
      const res = await axios.post(
        "https://ritehomepros.com/marketing_leads_backend/core/login/",
        {
          email: username.trim(),
          password,
        }
      );

      const data = res?.data || {};

      if (data?.token) {
        sessionStorage.setItem("authToken", data.token);
      }

      sessionStorage.setItem("username", username.trim());
      sessionStorage.setItem("userType", "admin");

      setSnack({
        open: true,
        message: "Logged in successfully",
        severity: "success",
      });

      navigate("/admin-user/appointments");
    } catch (err) {
      let message = "Login failed. Please check credentials.";
      if (err?.response?.data?.detail) message = err.response.data.detail;
      else if (err?.response?.data?.message)
        message = err.response.data.message;

      setSnack({ open: true, message, severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={rootStyles}>
      <style>{`
        .admin-card {
          width: 420px;
          border-radius: 12px;
          background: #ffffff;
          box-shadow: 0 12px 30px rgba(9, 76, 159, 0.12);
        }

        .admin-card-content {
          padding: 32px 28px 36px;
          display: flex;
          flex-direction: column;
        }

        .logo-wrap {
          display: flex;
          justify-content: center;
          margin-bottom: 16px;
        }

        .admin-logo {
          width: 115px;
          height: 100px;
          object-fit: contain;
          border-radius: 8px;
        }

        .admin-title {
          text-align: center;
          color: #094c9f;
          font-weight: 700;
          margin-bottom: 12px;
        }

        .admin-btn {
          margin-top: 14px;
          background-color: #094c9f;
          text-transform: none;
          font-weight: 600;
          padding: 10px;
        }

        .admin-btn:hover {
          background-color: #083b82;
        }

        @media (max-width: 480px) {
          .admin-card {
            width: 92%;
          }
        }
      `}</style>

      <Card className="admin-card">
        <CardContent className="admin-card-content">
          {/* Centered Logo */}
          <Box className="logo-wrap">
            <img src={logo} alt="logo" className="admin-logo" />
          </Box>

          <Typography variant="h5" className="admin-title">
            Admin Sign in
          </Typography>

          <form onSubmit={handleSubmit} noValidate>
            <TextField
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              fullWidth
              required
              margin="normal"
            />

            <TextField
              label="Password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              required
              margin="normal"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={toggleShowPassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              className="admin-btn"
              disabled={loading}
            >
              {loading ? <CircularProgress size={22} /> : "Login"}
            </Button>
          </form>
        </CardContent>
      </Card>

      <Snackbar
        open={snack.open}
        autoHideDuration={4500}
        onClose={closeSnack}
      >
        <Alert onClose={closeSnack} severity={snack.severity}>
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AdminLogin;

/* container styles */
const rootStyles = {
  minHeight: "85vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)",
  padding: "24px",
};
